/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { IPopup } from 'app/shared/elements/popup-base';
import { SaveUserDetails } from 'app/core/components/users/save-user-details';
import { validate } from 'app/shared/elements/ess-rule';
import * as Core from 'app/core/models/essette-api';

@autoinject()
export class UserDetails extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.object()
    protected user: Core.User | null = null;

    @bindable.boolean()
    protected isUserSynched: boolean = false;

    ////****************** Element References ***************************************////
    protected $modal!: IPopup;
    protected $form!: IForm;
    protected $saveUserDetails!: SaveUserDetails;
    protected validateForm = validate;
    protected formIsValid: boolean = false;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {

        super(...rest);
    }

    ////****************** Events ************************************************////

    protected openModal(): void {
        this.$saveUserDetails.reset();
        this.$modal.open();
    }

    protected closeModal(): void {
        this.$saveUserDetails.reset();
        this.$modal.close();
    }

    protected formSuccess() {
        this.$modal.close();
    }

    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////
}
